export const styles = {
  container: {
  padding: '0',
  maxWidth: '100%',
  overflow: 'hidden', // Prevent page-level horizontal scroll
  boxSizing: 'border-box',
},
  header: {
    backgroundColor: '#fff',
    padding: '16px 24px',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  },
  title: {
    margin: 0,
    fontSize: '15px',
    fontWeight: '600',
    color: '#333',
  },
  headerButtons: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  button: {
  padding: '6px 8px',
  border: '1px solid #d0d0d0',
  borderRadius: '4px',
  backgroundColor: '#fff',
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: 500,
  color: '#666',
  lineHeight: '1.2',
  height: 'fit-content',
  alignSelf: 'center',
  marginBottom: '12px',

},
  buttonPrimary: {
    padding: '8px 16px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#007bff',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '14px',
  },
  sidebar: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '16px',
    height: 'fit-content',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  sidebarTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#666',
    marginBottom: '12px',
  },
  entityItem: {
    padding: '10px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    marginBottom: '4px',
    color: '#333',
  },
  entityItemActive: {
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
  },
  entityPanel: {
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '24px',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  maxWidth: '100%',
  overflow: 'hidden', // Prevent horizontal expansion
  boxSizing: 'border-box', // Include padding in width calculation
},
  entityHeader: {
    marginBottom: '24px',
    display:'flex',
    justifyContent:'space-between'
  },
  entityTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '4px',
  },
  entitySubtitle: {
    fontSize: '13px',
    color: '#666',
  },
  section: {
    marginBottom: '32px',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    paddingBottom: '8px',
    borderBottom: '1px solid #e0e0e0',
    flexWrap: 'wrap',
    gap: '8px',
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
  },
  addButton: {
    padding: '6px 12px',
    border: '1px solid #d0d0d0',
    borderRadius: '4px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#333',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  tableHeader: {
    textAlign: 'left',
    padding: '12px 8px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#666',
    borderBottom: '1px solid #e0e0e0',
  },
  tableCell: {
    padding: '12px 8px',
    fontSize: '14px',
    color: '#333',
    borderBottom: '1px solid #f0f0f0',
  },
  checkIcon: {
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '3px',
    backgroundColor: '#d4edda',
    color: '#28a745',
    fontSize: '12px',
  },
  emptyCheck: {
    width: '20px',
    height: '20px',
    border: '1px solid #d0d0d0',
    borderRadius: '3px',
    backgroundColor: '#fff',
  },
  mappedBadge: {
    padding: '4px 8px',
    borderRadius: '3px',
    fontSize: '12px',
    fontWeight: '500',
  },
  relationshipItem: {
    padding: '12px',
    backgroundColor: '#f8f9fa',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
    color: '#333',
    flexWrap: 'wrap',
    gap: '8px',
  },
  relationshipText: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  },
  settingsPanel: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '16px',
    height: 'fit-content',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  settingsTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '16px',
  },
  settingsSection: {
    marginBottom: '20px',
  },
  settingsLabel: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#666',
    marginBottom: '8px',
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '8px',
    border: '1px solid #d0d0d0',
    borderRadius: '4px',
    fontSize: '13px',
    boxSizing: 'border-box',
  },
  select: {
    width: '100%',
    padding: '8px',
    border: '1px solid #d0d0d0',
    borderRadius: '4px',
    fontSize: '13px',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
  },
  identifierText: {
    fontSize: '13px',
    color: '#333',
    padding: '8px',
    backgroundColor: '#f8f9fa',
    borderRadius: '4px',
  },
};
